import * as React from 'react';
import * as c from 'models/constants';
import { IDefinedMenuItem, IMenuItemListItem } from 'models/menuitem/menuitemlistitem';
import { Link } from 'react-router';
import { MenuItemType } from 'models/enums/menuitemtype';
import renderIcon from 'helpers/renderIcon';
import { AvatarSmall } from 'components';
import { closeAllDropdowns } from 'helpers/hooks';
require('./style.css');

interface IProps {
	menuType: string;
	item: IMenuItemListItem | IDefinedMenuItem;
	menuItemType: MenuItemType;
	onShowNextLevelClick?: () => void;
	// onMouseEnter: (id: string) => void;
	// onMouseLeave: (e?: React.MouseEvent) => void;
	menuLevel: number;
	onMenuItemClick: () => void;
	t: (key: string) => string;
}

const MY_SALONS = 'MY_SALONS';

/**
 *
 * @param props
 */
export const ViewMenuTypeCommon = (props: IProps) => {
	let url = '';
	let title = props.item.title || '';
	const hasChildren = 'final' in props.item && !props.item.final;
	if (props.menuType === c.MENU_TYPE_PAGE) {
		title = props.item.title;
		if (props.menuItemType === MenuItemType.Portal && props.item?.id === MY_SALONS) {
			url = `/salons`;
		} else if (props.menuItemType === MenuItemType.Portal && props.item?.id !== MY_SALONS) {
			url = `/portal/page/${props.item.code}`;
		} else if (props.menuItemType === MenuItemType.Magazine) {
			url = `/magazine/page/${props.item.code}`;
		}
	} else if (props.menuType === c.MENU_TYPE_CATEGORY) {
		title = props.t(`DV_Categories_${props.item.title}`);
		url = `/search?cat=${props.item.title}`;
	} else if (props.menuType === c.MENU_TYPE_MAGAZINE_LINK) {
		title = props.item.title;
		url = `/magazine/page/${props.item.description}`;
	} else if (props.menuType === c.MENU_TYPE_PORTAL_LINK) {
		title = props.item.title;
		url = `/portal/page/${props.item.description}`;
	} else if (props.menuType === c.MENU_TYPE_SHOP) {
		title = props.item.title;
		url = `/shop/${props.item.code}`;
	}

	let image: JSX.Element | null = null;
	if ('icon' in props.item) {
		image = renderIcon(props.item.icon as any);
		if (image) {
			image = <figure className="avatarSmall">{image}</figure>;
		}
	}
	if ('imageUrl' in props.item && props.item.imageUrl) {
		image = <AvatarSmall imageUrl={props.item.imageUrl} name={title} />;
	}

	const showNextLevel = (e: React.MouseEvent) => {
		e.stopPropagation();
		if (props.onShowNextLevelClick) {
			props.onShowNextLevelClick();
		}
	};
	const onMenuItemClick = () => {
		if (props.onMenuItemClick) {
			props.onMenuItemClick();
		}
	};

	return (
		<div onClick={onMenuItemClick} className="menuItem">
			<Link to={url} key={props.item.id} onClick={url ? closeAllDropdowns : null}>
				{image}
				<span>{title.charAt(0).toUpperCase() + title.slice(1)}</span>
			</Link>
			{hasChildren ? (
				<button type="button" className="openSubmenu" onClick={showNextLevel}>
					{renderIcon('submenu')}
				</button>
			) : null}
		</div>
	);
};
